import {
  Badge,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from "@veritrellis/ui";
import {
  accessCapabilityKeys,
  buildRoleCapabilityMatrix,
  type AccessCapabilityKey,
  type AccessManifest
} from "@veritrellis/shared";
import type { WorkspaceRole } from "@veritrellis/shared/roles";
import { capabilityLabel } from "../../lib/capabilityPresentation.js";
import { workspaceRoleBadgeVariant } from "../../lib/workspaceRolePresentation.js";

const matrixRoles: WorkspaceRole[] = [
  "owner",
  "admin",
  "developer",
  "approver",
  "viewer",
  "auditor"
];

const CapCell = (input: { allowed: boolean }) =>
  input.allowed ? (
    <span className="admin-cap-yes">Yes</span>
  ) : (
    <span className="admin-cap-no">No</span>
  );

export const RoleCapabilityMatrix = (input: {
  strictProductionSeparation: boolean;
  highlightRole?: WorkspaceRole | null;
}) => {
  const matrix = buildRoleCapabilityMatrix({
    strictProductionSeparation: input.strictProductionSeparation
  });
  const byRole = new Map<WorkspaceRole, AccessManifest>(matrix.map((row) => [row.role, row]));

  return (
    <div className="admin-access-matrix-wrap">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="admin-access-matrix-cap-col">Capability</TableHead>
            {matrixRoles.map((role) => (
              <TableHead
                key={role}
                className={
                  input.highlightRole === role
                    ? "admin-access-matrix-role-col is-you"
                    : "admin-access-matrix-role-col"
                }
              >
                <Badge variant={workspaceRoleBadgeVariant(role)} className="text-xs">
                  {role}
                </Badge>
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {accessCapabilityKeys.map((key: AccessCapabilityKey) => (
            <TableRow key={key}>
              <TableCell className="admin-access-matrix-cap-col">
                <span className="text-sm">{capabilityLabel(key)}</span>
                <p className="admin-mono-inline admin-access-matrix-key">{key}</p>
              </TableCell>
              {matrixRoles.map((role) => {
                const manifest = byRole.get(role);
                const allowed = manifest?.can[key] === true;
                return (
                  <TableCell
                    key={`${role}-${key}`}
                    className={
                      input.highlightRole === role
                        ? "admin-access-matrix-role-col is-you"
                        : "admin-access-matrix-role-col"
                    }
                  >
                    <CapCell allowed={allowed} />
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
